import React, { Suspense, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { XCircle } from 'shared/assets/icons';
import { Colors, IconButton } from 'shared/components/ui/icon-button';
import { PageLoader } from 'shared/components/ui/page-loader';

import { AllTasks } from './all-tasks';
import { AllTasksFilters } from './all-tasks-filters';
import * as Styled from './side-panel.style';

export type SidePanelProps = {
  onClose: () => void;
};

export const SidePanel: React.FC<SidePanelProps> = ({ onClose }) => {
  const { t } = useTranslation();
  const scrollRef = useRef<HTMLDivElement>(null);

  return (
    <Styled.Container>
      <Styled.Header>
        <Styled.Title>{t('pages.upcoming.all-tasks.title')}</Styled.Title>
        <IconButton
          icon={XCircle}
          onClick={onClose}
          color={Colors.Default}
          preventDrag
        />
      </Styled.Header>

      <Styled.Filters>
        <AllTasksFilters />
      </Styled.Filters>

      <Styled.Content ref={scrollRef}>
        <Suspense fallback={<PageLoader />}>
          <AllTasks />
        </Suspense>
      </Styled.Content>
    </Styled.Container>
  );
};
